import { HTTP_STATUS_CODE, uploadRequest as uploadRequestWithoutErrorHandling } from '@luna/api';
import { logger } from '@luna/logger';

type ErrorResponse = {
    status: number;
    data?: {
        message?: string;
    };
};

type WrappedRequest<T> = typeof uploadRequestWithoutErrorHandling<T>;
type RequestParams<T> = Parameters<WrappedRequest<T>>;
type SuccessResponse<T> = Awaited<ReturnType<WrappedRequest<T>>>;
type Response<T> = SuccessResponse<T> | ErrorResponse;

const isHttpSuccess = <T>(response: Response<T>): response is SuccessResponse<T> =>
    response.status >= HTTP_STATUS_CODE.OK && response.status < HTTP_STATUS_CODE.MULTIPLE_CHOICES;

export const uploadRequest = <T>(...params: RequestParams<T>): Promise<T> =>
    uploadRequestWithoutErrorHandling<T>(...params).then((response: Response<T>) => {
        if (!isHttpSuccess(response)) {
            const errorMessage = `File upload failed: ${response.status}`;
            logger.error(errorMessage, response);
            throw new Error(response.data?.message || errorMessage);
        }
        return response.data;
    });
